<template>
    <div class="py-3 text-right">
        <b-button variant="primary" v-on="$listeners">
            <Bullseye class="mr-2" />
            <strong>{{ $t('label') }}</strong>
        </b-button>
    </div>
</template>

<script>
import { Bullseye } from '@/views/components/icons'

export default {
    name: 'NewObjectiveBtn',
    components: {
        Bullseye,
    },
    i18n: {
        messages: {
            'en-US': {
                label: 'New Objective',
            },
            'es-ES': {
                label: 'Nuevo Objetivo',
            },
            'pt-BR': {
                label: 'Novo Objetivo',
            },
        },
    },
}
</script>
